import React from 'react';
import styles from '../../styles/CierreCicloEscolarStyles/CierreCicloEscolar.module.css';

function FilterSection({
  filters,
  onFilterChange,
  onApply,
  campusList,
  seccionesList,
  ciclosList,
  cicloSeleccionadoId,
  onCicloChange,
  cicloActualId,
  loading,
}) {
  return (
    <div className={styles.filterSection}>
      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Campus</label>
        <select
          className={styles.filterInput}
          value={filters.campus}
          onChange={(e) => onFilterChange('campus', e.target.value)}
          disabled={loading}
        >
          <option value="">Todos</option>
          {campusList.map((c) => (
            <option key={c.id} value={c.id}>{c.nombre}</option>
          ))}
        </select>
      </div>

      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Sección Académica</label>
        <select
          className={styles.filterInput}
          value={filters.seccion}
          onChange={(e) => onFilterChange('seccion', e.target.value)}
          disabled={loading}
        >
          <option value="">Todas</option>
          {seccionesList.map((s) => (
            <option key={s.id} value={s.id}>{s.nombre}</option>
          ))}
        </select>
      </div>

      <div className={styles.filterGroup}>
        <label className={styles.filterLabel}>Ciclo Escolar</label>
        <select
          className={styles.filterInput}
          value={cicloSeleccionadoId || ''}
          onChange={(e) => onCicloChange(e.target.value)}
          disabled={loading}
          title="El ciclo actual viene seleccionado por defecto. Puedes elegir un ciclo anterior (desde 2026-1) para cerrarlo."
        >
          {(ciclosList || []).map((c) => (
            <option key={c.id} value={c.id}>
              {c.nombre}{String(c.id) === String(cicloActualId) ? ' (Actual)' : ''}
            </option>
          ))}
        </select>
      </div>

      <button className={styles.applyButton} onClick={onApply} disabled={loading}>
        APLICAR
      </button>
    </div>
  );
}

export default FilterSection;
